// @file modules/advocacy_campaign.js
// @description Reskin behavior for the member advocacy interstitial.
//              - Sizes the message textarea to its content so the copy
//                button sits flush below the text.
//              - Copies the prefilled message to the clipboard from the
//                tertiary fragno-button next to the textarea.
//              - Reveals the fragno-alerts hint after 3+ CTA clicks
//                (mirrors the legacy frustration-counter UX).

import { dispatchTrack } from "analytics/shop-analytics-track";

export const HINT_REVEAL_THRESHOLD = 3;
export const COPY_FEEDBACK_DURATION_MS = 1500;

export function autoSizeMessages() {
  document.querySelectorAll(".advocacy-interstitial__message").forEach((el) => {
    // Reset to auto first so scrollHeight reflects content height, not the
    // previously-set value. Standard textarea auto-resize pattern.
    el.style.height = "auto";
    el.style.height = `${el.scrollHeight}px`;
  });
}

export function setupCopyButtons() {
  document
    .querySelectorAll(".advocacy-interstitial__copy")
    .forEach((button) => {
      button.addEventListener("click", async () => {
        const target = document.querySelector(button.dataset.target);
        const labels = button.dataset;
        const container = button.closest(
          ".advocacy-interstitial__messagecontainer",
        );
        if (!target || !container) return;

        try {
          await navigator.clipboard.writeText(target.value);
          button.setAttribute("label", labels.copySuccessLabel);
          container.classList.add("copied");
          setTimeout(() => {
            button.setAttribute("label", labels.copyLabel);
            container.classList.remove("copied");
          }, COPY_FEEDBACK_DURATION_MS);
        } catch {
          button.setAttribute("label", labels.copyErrorLabel);
          container.classList.add("copy-error");
          setTimeout(() => {
            button.setAttribute("label", labels.copyLabel);
            container.classList.remove("copy-error");
          }, COPY_FEEDBACK_DURATION_MS);
        }
      });
    });
}

export function setupHintCounter() {
  const cta = document.getElementById("advocacy_continue");
  const hint = document.getElementById("advocacy_hint");
  if (!cta || !hint) return;

  let clicks = 0;
  cta.addEventListener("click", () => {
    clicks += 1;
    if (clicks >= HINT_REVEAL_THRESHOLD && hint.hasAttribute("hidden")) {
      hint.removeAttribute("hidden");
      // fragno-alerts has no "open" event for the analytics observer to bind
      // to, so we dispatch the GA4 event here when the alert is revealed.
      const eventName = hint.dataset.eventName;
      if (!eventName) return;
      let params = {};
      try {
        params = JSON.parse(hint.dataset.eventParams || "{}");
      } catch {
        // leave params empty on malformed JSON
      }
      dispatchTrack(hint, eventName, params);
    }
  });
}

export function initAdvocacyCampaign() {
  autoSizeMessages();
  setupCopyButtons();
  setupHintCounter();
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initAdvocacyCampaign);
} else {
  initAdvocacyCampaign();
}
